import { render, staticRenderFns } from "./google-sign-in-button.vue?vue&type=template&id=5e794e4b&scoped=true"
import script from "./google-sign-in-button.vue?vue&type=script&lang=js"
export * from "./google-sign-in-button.vue?vue&type=script&lang=js"
import style0 from "./google-sign-in-button.vue?vue&type=style&index=0&id=5e794e4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e794e4b",
  null
  
)

export default component.exports